import { Component, OnInit } from '@angular/core';
import { config } from '../../../config';
@Component({
  selector: 'ngx-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  serverUrl = config.serverUrl;
  constructor() { }

  ngOnInit() {
  }

}
